// 关于我们
export const PATH_ABOUT = '/about'
export const PATH_DOWNLOAD = '/download'
